import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolders2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolders2"><Path d="M3.5 18.5H19V20H2V6H3.5V18.5ZM12.5605 5H22V17H5V3H10.5605L12.5605 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolders2;
